import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Paper, Divider } from '@mui/material';

import { useLoading } from '@/shared/context/UIContextProvider';
import { useAlert } from '@/contexts/Alert/AlertContext';

import { Project, Unit } from '@urbanmix-tech/shared-js';
import {
  getProjectById,
  getUnitsByProjectId,
} from '@/data';
import { ImportRentRoll } from '@/components/ImportRentRoll/ImportRentRoll';
import { RegenerateUnitsForm } from '@/components/BuildingCreation/RegenerateUnitsForm';
import { CreateUnitsFromEntrata } from '@/components/ImportRentRoll/CreateUnitsFromEntrata';

export const ImportRentRollPage = () => {
  const { projectId, buildingId } = useParams<{
    projectId: string;
    buildingId: string;
  }>();
  const { createLoading } = useLoading();
  const { showAlert } = useAlert();

  const [project, setProject] = useState<Project | null>(null);
  const [units, setUnits] = useState<Unit[]>([]);

  useEffect(() => {
    console.log('units', units);
  }, []);

  useEffect(() => {
    if (projectId) {
      const loader = createLoading();

      loader.startLoading({ title: 'Loading Project...' });
      getProjectById(projectId).then((value) => {
        getUnitsByProjectId(projectId).then((_units) => {
          setUnits(_units);
          if (value && value.buildings.length > 0) {
            setProject(value);
          } else {
            showAlert('Building not exists!', 'error');
          }
          loader.stopLoading();
        });
      });
    } else {
      showAlert(
        'There is something wrong, please check your connectivity!',
        'error'
      );
    }
  }, [projectId, buildingId, showAlert, createLoading]);

  const handleRegenerateComplete = () => {
    // Reload units after regeneration
    if (projectId) {
      getUnitsByProjectId(projectId).then((_units) => {
        setUnits(_units);
      });
    }
  };

  return (
    <div className="relative flex h-full w-full overflow-y-auto border-red-500">
      <div className="w-full pb-60">
        {project && project.buildings.length > 0 ? (
          <>
            {units.length === 0 ? (
              <Box className="w-full px-[100px] pb-[3em] pt-6">
                <Paper className="rounded-2xl bg-white/5 p-24">
                  <Typography variant="h4" color="textPrimary" sx={{ mb: 3 }}>
                    No Units Found
                  </Typography>
                  <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
                    It looks like the unit creation process may have failed or been interrupted.
                    You can create units from Entrata exports or regenerate them manually below.
                  </Typography>
                  <CreateUnitsFromEntrata
                    projectId={String(project.id)}
                    buildingId={parseInt(buildingId || '1')}
                    onComplete={handleRegenerateComplete}
                  />
                  <Divider sx={{ my: 3 }}>OR</Divider>
                  <RegenerateUnitsForm
                    projectId={String(project.id)}
                    buildingId={parseInt(buildingId || '1')}
                    floors={project.buildings[0]?.floors || 1}
                    onComplete={handleRegenerateComplete}
                  />
                </Paper>
              </Box>
            ) : (
              <ImportRentRoll key={project.id} projectId={String(project.id)} />
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};
